import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";

// Mateix disseny/patró que Inicio/Comentarios.jsx (carrusel horitzontal,
// classes .bh-comentarios*/.bh-testimonio* compartides via global.css),
// aquí només amb els comentaris d'aquesta propietat concreta — les dades
// ja arriben (PropiedadController::fichapropiedad ja calcula
// $comentariosprop), no calia tocar el backend.
const ComentariosPropiedad = ({ comentarios, lang, config, ruta }) => {

    const { t } = useTranslation();

    let coms = [];

    {
        comentarios.forEach((uncomentario, index) => {
            let iconosestrellas = "";
            for (let i = 0; i < uncomentario.estrellas; i++) {
                iconosestrellas += "<i class='fa-solid fa-star' style='color:" + config.color_corporativo_web + "'></i>";
            }

            const primerTitulo = Object.values(uncomentario.titulo || {}).find(Boolean);
            const primerTexto = Object.values(uncomentario.texto || {}).find(Boolean);

            let objeto = {
                id: index,
                identificador: uncomentario.id,
                titulo: uncomentario.titulo?.[lang] || primerTitulo,
                texto: uncomentario.texto?.[lang] || primerTexto,
                estrellas: iconosestrellas,
                persona: uncomentario.nombre_persona,
                origen: uncomentario.origen,
                imagen: uncomentario.imagen
            }
            coms = coms.concat(objeto);
        })
    }

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bh-testimonio', coms.length);

    return (
        config.activa_comentarios_web == 1 && comentarios.length > 0 ?
            <div className="bh-comentarios">
                <div className="bhh-section__head">
                    <h3 className="text-center">{t("Comentarios")}</h3>
                </div>

                <div className="bh-comentarios__carousel">
                    {coms.length > 2 &&
                        <button
                            type="button"
                            disabled={navState.atStart}
                            onClick={() => scrollByCard(-1)}
                            className="bhh-destacados__prev"
                            aria-label={t("Anterior")}
                        >
                            <i className="fa-solid fa-arrow-left"></i>
                        </button>
                    }
                    <div className="bh-comentarios__track" ref={trackRef}>
                        {coms.map((comentario) => (
                            <div className="bh-testimonio" key={comentario.id}>
                                <div className="bh-testimonio__card">
                                    {comentario.imagen &&
                                        <div className="bh-testimonio__avatar">
                                            <img src={ruta + "/comentarios/" + comentario.identificador + "/" + comentario.imagen} alt={comentario.persona} />
                                        </div>
                                    }
                                    <div className="bh-testimonio__estrellas">
                                        {ReactHtmlParser(comentario.estrellas)}
                                    </div>
                                    {comentario.origen &&
                                        <div className="bh-testimonio__origen">{comentario.origen}</div>
                                    }
                                    <div className="bh-testimonio__texto bh-testimonio__texto--sense-cometes">
                                        {ReactHtmlParser(comentario.texto)}
                                    </div>
                                    <div className="bh-testimonio__persona">{comentario.persona}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {coms.length > 2 &&
                        <button
                            type="button"
                            disabled={navState.atEnd}
                            onClick={() => scrollByCard(1)}
                            className="bhh-destacados__next"
                            aria-label={t("Siguiente")}
                        >
                            <i className="fa-solid fa-arrow-right"></i>
                        </button>
                    }
                </div>
            </div>
            :
            <></>
    );
};
export default ComentariosPropiedad;
